<template>
  <Modal :show="show" tabindex="-1" @close="closeModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Parent Information</h5>
        </div>
        <div class="modal-body">
          <div v-if="parentItinerary" class="card mb-3">
            <div class="card-header">
              Parent Itinerary
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Code</small>
                  <strong>{{ parentItinerary.itinerary_code }}</strong>
                </div>
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Title</small>
                  <strong>{{ parentItinerary.titleitinerary }}</strong>
                </div>
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Start Date</small>
                  <strong>{{ parentItinerary.fromitinerary }}</strong>
                </div>
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">End Date</small>
                  <strong>{{ parentItinerary.toitinerary }}</strong>
                </div>
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Status</small>
                  <span
                    class="badge"
                    :class="parentItinerary.enabled_status ? 'bg-success' : 'bg-danger'"
                  >
                    {{ parentItinerary.enabled_status ? 'Enabled' : 'Disabled' }}
                </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="parentTour" class="card">
            <div class="card-header">
              Parent Tour
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Name</small>
                  <strong>{{ parentTour.nameTour }}</strong>
                </div>
                <div class="col-md-6 mb-3">
                  <small class="text-muted d-block">Brand</small>
                  <strong>{{ parentTour.brand_name }}</strong>
                </div>
                <div class="col-md-6">
                  <small class="text-muted d-block">Status</small>
                  <span
                    class="badge"
                    :class="parentTour.enabled_status ? 'bg-success' : 'bg-danger'"
                  >
                    {{ parentTour.enabled_status ? 'Enabled' : 'Disabled' }}
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/_shared/Modal.vue";
import BaseInputForm from "@/components/_base/BaseInputForm.vue";

export default {
  name: "ParentInfoModal",
  components: {BaseInputForm, Modal},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    parentItinerary: Object,
    parentTour: Object,
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
